import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header({ onSincronizar, sincronizando, onAgendarMensagem }) {
  const location = useLocation();

  const getUserName = () => {
    try { return JSON.parse(localStorage.getItem('prospera_user') || '{}').name || 'Usuário'; }
    catch { return 'Usuário'; }
  };

  const getInitials = () => {
    const n = getUserName().split(' ');
    return n.length >= 2 ? (n[0][0]+n[n.length-1][0]).toUpperCase() : getUserName().substring(0,2).toUpperCase();
  };

  const handleLogout = () => { localStorage.removeItem('prospera_user'); window.location.href = '/login.html'; };

  const setTheme = (t) => { document.documentElement.setAttribute('data-theme', t); localStorage.setItem('prospera_theme', t); };
  const isDark = () => document.documentElement.getAttribute('data-theme') === 'dark';

  if (location.pathname === '/') return null;

  return (
    <>
      <header className="pp-header">
        <div className="pp-header-left">
          <Link to="/" className="pp-brand"><div className="pp-brand-icon">P</div><div className="pp-brand-name">Prospera<sup>+</sup></div></Link>
          <div className="pp-header-sep"></div>
          <Link to="/" className="pp-btn-home">🏠 Home</Link>
        </div>
        <div className="pp-header-right">
          <button className="pp-btn-sync" onClick={onSincronizar} disabled={sincronizando}><span className="pp-sync-dot"></span>{sincronizando ? 'Sincronizando...' : 'Sincronizar'}</button>
          <button className="pp-btn-agendar" onClick={onAgendarMensagem}>📅 Agendar Mensagem</button>
          <div className="pp-theme-toggle">
            <button className={'pp-theme-btn '+(!isDark()?'active':'')} onClick={()=>setTheme('light')}>☀️</button>
            <button className={'pp-theme-btn '+(isDark()?'active':'')} onClick={()=>setTheme('dark')}>🌙</button>
          </div>
          <div className="pp-user-section">
            <div className="pp-user-avatar">{getInitials()}</div>
            <span className="pp-user-name">{getUserName().split(' ')[0]}</span>
            <button className="pp-btn-logout" onClick={handleLogout}>Sair</button>
          </div>
        </div>
      </header>
      <nav className="pp-nav">
        <Link to="/servicos" className={'pp-nav-item '+(location.pathname==='/servicos'?'active':'')}>Dashboard Serviços</Link>
        <Link to="/financeiro" className={'pp-nav-item '+(location.pathname==='/financeiro'?'active':'')}>Financeiro</Link>
        <Link to="/relatorios" className={'pp-nav-item '+(location.pathname==='/relatorios'?'active':'')}>Relatórios</Link>
        <Link to="/metas" className={'pp-nav-item '+(location.pathname==='/metas'?'active':'')}>Metas</Link>
        <Link to="/fiscal" className={'pp-nav-item '+(location.pathname==='/fiscal'?'active':'')}>Gestão Fiscal</Link>
        <Link to="/marketplace" className={'pp-nav-item '+(location.pathname==='/marketplace'?'active':'')}>Marketplace</Link>
      </nav>
    </>
  );
}
export default Header;
